import { render } from "./orderMeMultiCode.vue?vue&type=template&id=a56c4fa4"
import script from "./orderMeMultiCode.vue?vue&type=script&lang=js"
export * from "./orderMeMultiCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__